import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
import { apiurl } from "../../../../../path";
import {
  Email32,
  Location32,
  PhoneNumber32,
} from "../../../../../public/LoginImages/importimages";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
import GooglePagination from "../../../styles/GooglePagination";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const VendorApproval = () => {
  const { t } = useLanguage();

  const context = useContext(AdminContext);

  const {
    GetVendorInwardsList,
    VendorApprovalOperation,
  } = context;

  const [vendors, setVendors] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [selectedBills, setSelectedBills] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [SelectedOptions, setSelectedOptions] = useState("Pending");

  const [remark, setRemark] = useState("");
  const [rejectPanelhide, setRejectpanelhide] = useState(0);

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;

  const totalPages = Math.ceil(filteredBills.length / billsPerPage);

  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;

  const sortedBills = Array.isArray(filteredBills)
    ? filteredBills.slice()
    : [];

  const currentBills = sortedBills.slice(
    indexOfFirstBill,
    indexOfLastBill
  );

  // ================= GET DATA =================

  const getVendorApprovalList = async () => {
    let data = await GetVendorInwardsList();

    setVendors(data || []);
    setFilteredBills(data || []);
  };

  useEffect(() => {
    getVendorApprovalList();
  }, []);

  // ================= FILTER =================

  useEffect(() => {
    let filtered = vendors;

    if (SelectedOptions) {
      filtered = filtered.filter(
        (item) => item.Status === SelectedOptions
      );
    }

    if (searchTerm) {
      const lowerSearchTerm = searchTerm.toLowerCase();

      filtered = filtered.filter((bill) =>
        Object.values(bill).some((val) =>
          (val || "")
            .toString()
            .toLowerCase()
            .includes(lowerSearchTerm)
        )
      );
    }

    // setFilteredBills(filtered);
    setCurrentPage(1);
  }, [vendors, searchTerm, SelectedOptions]);

  // ================= CHECKBOX =================

  const handleCheckboxChange = (id) => {
    setSelectedBills((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((billId) => billId !== id)
        : [...prevSelected, id]
    );
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedBills(currentBills.map((bill) => bill.UniqueID));
    } else {
      setSelectedBills([]);
    }
  };

  // ================= APPROVE / REJECT =================

  const approveorrejectSelected = async (condition) => {
    if (selectedBills.length === 0) {
      alert("No Vendor Selected!");
      return;
    }

    if (condition === "Rejected" || condition === "SendBack") {
      const cleanRemark = remark.trim().replace(/\s+/g, " ");

      if (!cleanRemark) {
        alert("Remark is required!");
        return;
      }
    }

    let shouldStart = window.confirm(
      `Are you sure want to ${condition} vendors ?`
    );

    if (!shouldStart) return;

    setLoading(true);

    try {
      const response = await VendorApprovalOperation(
        selectedBills,
        condition,
        remark
      );

      if (response?.message) {
        alert(response.message);
      }

      if (response?.error) {
        alert(response.error);
      }

      setRemark("");
      setRejectpanelhide(0);
      setSelectedBills([]);

      await getVendorApprovalList();
    } catch (error) {
      console.log(error);
      alert("Something went wrong!");
    }

    setLoading(false);
  };

  // ================= REJECT PANEL =================

  const rejectSendbackbeforecheckup = (id) => {
    if (selectedBills.length <= 0) {
      alert("Please Select Vendor!");
      return;
    }

    setRejectpanelhide(id);
  };

  
  // ================= EXPORT =================

const exportToExcel = () => {
  if (!filteredBills || filteredBills.length === 0) {
    alert("No data available");
    return;
  }

  try {
    const excelData = filteredBills.map((v, index) => ({
      "Sr.No": index + 1,
      "Unique ID": v.UniqueID || "-",
      "Company Name": v.Bidder_CompanyName || "-",
      Email: v.Email || "-",
      Address: v.Address || "-",
      City: v.City || "-",
      Pincode: v.PinCode || "-",
      "Phone Number": v.Mobile_No || "-",
      "GST Number": v.GST_No || "-",
      "PAN Number": v.PAN_No || "-",
      "Account Number": v.Account_Number || "-",
      "Bank Name": v.BANK_NAME || "-",
      "IFSC Code": v.IFSC_CODE || "-",
      "Branch Name": v.BranchName || "-",
      "Passbook Doc": v.PaasbookDoc
        ? `${apiurl}/ContractorDocsImages/${v.PaasbookDoc}`
        : "-",
      "Cheque Doc": v.ChequeDoc
        ? `${apiurl}/ContractorDocsImages/${v.ChequeDoc}`
        : "-",
      "PAN Doc": v.PanDoc
        ? `${apiurl}/ContractorDocsImages/${v.PanDoc}`
        : "-",
      "TAN Doc": v.TanDoc
        ? `${apiurl}/ContractorDocsImages/${v.TanDoc}`
        : "-",
      "GST Doc": v.GstDoc
        ? `${apiurl}/ContractorDocsImages/${v.GstDoc}`
        : "-",
      "Aadhar Doc": v.AadharDoc
        ? `${apiurl}/ContractorDocsImages/${v.AadharDoc}`
        : "-",
      ...(SelectedOptions !== "Pending" && { Remark: v.Remark || "-" }),
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 24 }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Vendors");
    XLSX.writeFile(workbook, `Vendor_${SelectedOptions}_Report.xlsx`);
  } catch (error) {
    console.error("Excel Export Error:", error);
    alert("Excel export failed");
  }
};

const exportToPDF = () => {
  if (!filteredBills || filteredBills.length === 0) {
    alert("No data available");
    return;
  }

  try {
    const doc = new jsPDF("l", "mm", "a3"); // landscape, A3 for many columns
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text(`Vendor ${SelectedOptions} Report`, pageWidth / 2, 14, {
      align: "center",
    });

    const showRemark = SelectedOptions !== "Pending";

    const head = [
      [
        "Sr.No",
        "Unique ID",
        "Company Name",
        "Email",
        "Address",
        "City",
        "Pincode",
        "Phone",
        "GST No",
        "PAN No",
        "Account No",
        "Bank",
        "IFSC",
        "Branch",
        ...(showRemark ? ["Remark"] : []),
      ],
    ];

    const body = filteredBills.map((v, index) => [
      index + 1,
      v.UniqueID || "-",
      v.Bidder_CompanyName || "-",
      v.Email || "-",
      v.Address || "-",
      v.City || "-",
      v.PinCode || "-",
      v.Mobile_No || "-",
      v.GST_No || "-",
      v.PAN_No || "-",
      v.Account_Number || "-",
      v.BANK_NAME || "-",
      v.IFSC_CODE || "-",
      v.BranchName || "-",
      ...(showRemark ? [v.Remark || "-"] : []),
    ]);

    autoTable(doc, {
      head,
      body,
      startY: 22,
      styles: { fontSize: 7, cellPadding: 2, overflow: "linebreak" },
      headStyles: { fillColor: [44, 120, 219], textColor: 255 },
      alternateRowStyles: { fillColor: [229, 244, 251] },
      margin: { left: 8, right: 8 },
      didDrawPage: () => {
        doc.setFontSize(8);
        doc.text(
          `Page ${doc.internal.getNumberOfPages()}`,
          pageWidth - 20,
          doc.internal.pageSize.getHeight() - 6
        );
      },
    });

    doc.save(`Vendor_${SelectedOptions}_Report.pdf`);
  } catch (error) {
    console.error("PDF Export Error:", error);
    alert("PDF export failed");
  }
};


  return (
    <>
      <div
        className="col-12 pb-5"
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
        }}
      >
        <div className="col-11 m-auto">
          {/* ================= HEADER ================= */}

          <div
            className="col-12 px-4 mb-4 mt-3"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h5 className="my-auto fw-bold">
              <img
                src="/GR-Approval64.png"
                alt="Vendor Approval"
                style={{ width: "24px", height: "24px" }}
                className="my-auto me-1"
              />

              <span>{t("Vendor Approval")}</span>
            </h5>

  <div className="d-flex gap-2">
  <button className="btn btn-success" onClick={exportToExcel}>
    {t("Download Excel")}
  </button>
  <button className="btn btn-danger" onClick={exportToPDF}>
    {t("Download PDF")}
  </button>
</div>

          </div>

          {/* ================= LOADER ================= */}

          {loading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(255,255,255,0.7)",
                zIndex: 9999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  border: "6px solid #f3f3f3",
                  borderTop: "6px solid #007bff",
                  borderRadius: "50%",
                  width: "60px",
                  height: "60px",
                  animation: "spin 1s linear infinite",
                }}
              />

              <style>
                {`
                  @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
                `}
              </style>
            </div>
          )}

          {/* ================= ACTION BUTTONS ================= */}

          {/* {SelectedOptions === "Pending" && (
            <div
              className="col-12 mb-3 px-4"
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "end",
              }}
            >
              <button
                className="btn btn-success"
                onClick={() =>
                  approveorrejectSelected("Approved")
                }
              >
                {t("Approve")}
              </button>

              <button
                className="btn btn-warning text-white"
                onClick={() =>
                  rejectSendbackbeforecheckup(1)
                }
              >
                {t("Send Back")}
              </button>

              <button
                className="btn btn-danger"
                onClick={() =>
                  rejectSendbackbeforecheckup(2)
                }
              >
                {t("Reject")}
              </button>
            </div>
          )} */}

          {/* ================= REMARK PANEL ================= */}

          {rejectPanelhide !== 0 && (
            <div
              className="col-12 mb-3"
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "12px",
              }}
            >
              <textarea
                className="form-control"
                rows={4}
                placeholder={t("Enter Remark")}
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />

              <div
                className="mt-3"
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "end",
                }}
              >
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setRejectpanelhide(0);
                    setRemark("");
                  }}
                >
                  {t("Cancel")}
                </button>

                <button
                  className="btn btn-primary"
                  onClick={() =>
                    approveorrejectSelected(
                      rejectPanelhide === 1 ? "SendBack" : "Rejected",
                    )
                  }
                >
                  {t("Submit")}
                </button>
              </div>
            </div>
          )}

          {/* ================= TABLE ================= */}

          <div
            className="m-auto mb-3"
            style={{
              backgroundColor: "white",
              padding: "30px",
              boxShadow: "0px 0px 5px 1px #E4E8EC",
              borderRadius: "20px",
              overflowX: "auto",
            }}
          >
            <div
              className="col-12 tableDesign"
              style={{
                background: "#2C78DB",
                overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative", 
              }}
            >
              <table
                className="m-0 p-0"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  whiteSpace: "nowrap",
                }}
              >
                <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                  <tr
                    style={{
                      color: "white",
                      height: "3rem",
                      fontSize: "18px",
                    }}
                  >
                    <th style={{ padding: "12px" }}>
                      <input
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={
                          selectedBills.length === currentBills.length &&
                          currentBills.length > 0
                        }
                      />
                    </th>

                    <th style={{ padding: "8px" }}>{t("Sr.no")}</th>

                    <th style={{ padding: "8px" }}>{t("Unique ID")}</th>

                    <th style={{ padding: "8px" }}>{t("Company Name")}</th>

                    <th style={{ padding: "8px" }}>{t("Email")}</th>

                    <th style={{ padding: "8px" }}>{t("Address")}</th>

                    <th style={{ padding: "8px" }}>{t("City")}</th>

                    <th style={{ padding: "8px" }}>{t("Pincode")}</th>

                    <th style={{ padding: "8px" }}>{t("Phone Number")}</th>

                    <th style={{ padding: "8px" }}>{t("GST NUMBER")}</th>

                    <th style={{ padding: "8px" }}>{t("PAN NUMBER")}</th>

                    <th style={{ padding: "8px" }}>{t("Account Number")}</th>

                    <th style={{ padding: "8px" }}>{t("Bank Name")}</th>

                    <th style={{ padding: "8px" }}>{t("IFSC CODE")}</th>

                    <th style={{ padding: "8px" }}>{t("Branch Name")}</th>

                    <th style={{ padding: "8px" }}>{t("Passbook Doc")}</th>

                    <th style={{ padding: "8px" }}>{t("Cheque Doc")}</th>

                    <th style={{ padding: "8px" }}>{t("Pan Doc")}</th>

                    <th style={{ padding: "8px" }}>{t("Tan Doc")}</th>

                    <th style={{ padding: "8px" }}>{t("GST Doc")}</th>

                    <th style={{ padding: "8px" }}>{t("Aadhar Doc")}</th>

                    {SelectedOptions !== "Pending" && (
                      <th style={{ padding: "8px" }}>{t("Remark")}</th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {currentBills.length <= 0 ? (
                    <tr>
                      <td
                        colSpan="25"
                        style={{
                          textAlign: "center",
                          padding: "20px",
                          backgroundColor: "#f9f9f9",
                        }}
                      >
                        {t("No data available")}
                      </td>
                    </tr>
                  ) : (
                    currentBills.map((vendor, index) => {
                      const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                      return (
                        <tr
                          key={index}
                          style={{
                            backgroundColor: bgColor,
                            fontSize: "18px",
                            fontWeight: "500",
                          }}
                        >
                          {SelectedOptions === "Pending" && (
                            <td 
                              style={{
                                textAlign: "center",
                                padding: "8px" 
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={selectedBills.includes(
                                  vendor.UniqueID,
                                )}
                                onChange={() =>
                                  handleCheckboxChange(vendor.UniqueID)
                                }
                              />
                            </td>
                          )}

                          <td style={{ padding: "8px" }}>
                            {(currentPage - 1) * billsPerPage + index + 1}
                          </td>

                          <td style={{ padding: "8px" }}>{vendor.UniqueID}</td>

                          <td style={{ padding: "8px" }}>
                            {vendor.Bidder_CompanyName}
                          </td>

                          <td style={{ padding: "8px" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <img
                                src={Email32}
                                alt="email"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                }}
                              />

                              <span>{vendor.Email}</span>
                            </div>
                          </td>

                          <td style={{ padding: "8px" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <img
                                src={Location32}
                                alt="address"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                }}
                              />

                              <span>{vendor.Address}</span>
                            </div>
                          </td>

                          <td style={{ padding: "8px" }}>{vendor.City}</td>

                          <td style={{ padding: "8px" }}>{vendor.PinCode}</td>

                          <td style={{ padding: "8px" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <img
                                src={PhoneNumber32}
                                alt="phone"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                }}
                              />

                              <span>{vendor.Mobile_No}</span>
                            </div>
                          </td>

                          <td style={{ padding: "8px" }}>{vendor.GST_No}</td>

                          <td style={{ padding: "8px" }}>{vendor.PAN_No}</td>

                          <td style={{ padding: "8px" }}>
                            {vendor.Account_Number}
                          </td>

                          <td style={{ padding: "8px" }}>{vendor.BANK_NAME}</td>

                          <td style={{ padding: "8px" }}>{vendor.IFSC_CODE}</td>

                          <td style={{ padding: "8px" }}>
                            {vendor.BranchName}
                          </td>

                          {/* PASSBOOK */}

                          <td style={{ padding: "8px" }}>
                            {vendor.PaasbookDoc ? (
                              <a
                                href={`${apiurl}/ContractorDocsImages/${vendor.PaasbookDoc}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {vendor.PaasbookDoc}
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>

                          {/* CHEQUE */}

                          <td style={{ padding: "8px" }}>
                            {vendor.ChequeDoc ? (
                              <a
                                href={`${apiurl}/ContractorDocsImages/${vendor.ChequeDoc}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {vendor.ChequeDoc}
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>

                          {/* PAN */}

                          <td style={{ padding: "8px" }}>
                            {vendor.PanDoc ? (
                              <a
                                href={`${apiurl}/ContractorDocsImages/${vendor.PanDoc}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {vendor.PanDoc}
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>

                          {/* TAN */}

                          <td style={{ padding: "8px" }}>
                            {vendor.TanDoc ? (
                              <a
                                href={`${apiurl}/ContractorDocsImages/${vendor.TanDoc}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {vendor.TanDoc}
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>

                          {/* GST */}

                          <td style={{ padding: "8px" }}>
                            {vendor.GstDoc ? (
                              <a
                                href={`${apiurl}/ContractorDocsImages/${vendor.GstDoc}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {vendor.GstDoc}
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>

                          {/* AADHAR */}

                          <td style={{ padding: "8px" }}>
                            {vendor.AadharDoc ? (
                              <a
                                href={`${apiurl}/ContractorDocsImages/${vendor.AadharDoc}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {vendor.AadharDoc}
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>

                          {SelectedOptions !== "Pending" && (
                            <td style={{ padding: "8px" }}>
                              {vendor.Remark || "-"}
                            </td>
                          )}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* ================= PAGINATION ================= */}

            <div className="col-12 mt-4">
              <div className="row">
                <div className="col-6">
                  <p style={{ fontSize: "18px" }}>
                    {t("Showing")}{" "}
                    {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
                    {t("to")} {Math.min(indexOfLastBill, filteredBills.length)}{" "}
                    {t("of")} {filteredBills.length} {t("entries")}
                  </p>
                </div>
  <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                                            <GooglePagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                onPageChange={setCurrentPage}
                                            />
                                        </div>

                <div
                  className="col-6 text-start"
                  style={{ display: "flex", justifyContent: "left" }}
                >
                  <button
                    onClick={() => approveorrejectSelected("Approved")}
                    disabled={selectedBills.length <= 0 ? true : loading}
                    className="ms-0"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.3rem",
                      margin: "12px",
                      padding: "8px 10px",
                      fontWeight: "600",
                      backgroundColor:
                        selectedBills.length <= 0
                          ? "rgba(141, 141, 141, 0.97)"
                          : "#39B54A",
                      color: "white",
                      borderRadius: "8px",
                      cursor:
                        selectedBills.length <= 0
                          ? "not-allowed"
                          : loading
                            ? "not-allowed"
                            : "pointer",
                    }}
                  >
                    <img
                      src="/Approve-Selected32.png"
                      style={{
                        width: "1rem",
                        height: "1rem",
                        filter: "brightness(0) invert(1)",
                      }}
                    />{" "}
                    {loading ? "Processing..." : "Approve Selected"}
                  </button>

                  <button
                    onClick={() => rejectSendbackbeforecheckup(2)}
                    disabled={selectedBills.length <= 0 ? true : loading}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.3rem",
                      margin: "12px",
                      padding: "8px 10px",
                      fontWeight: "600",
                      background:
                        selectedBills.length <= 0
                          ? "rgba(141, 141, 141, 0.97)"
                          : "#C1272D",
                      color: "white",
                      borderRadius: "8px",
                      cursor:
                        selectedBills.length <= 0
                          ? "not-allowed"
                          : loading
                            ? "not-allowed"
                            : "pointer",
                    }}
                  >
                    <img
                      src="/Reject-Selected32.png"
                      style={{
                        width: "1rem",
                        height: "1rem",
                        filter: "brightness(0) invert(1)",
                      }}
                    />{" "}
                    {loading ? "Processing..." : "Reject Selected"}
                  </button>

                  {/* <button
                                                onClick={() => rejectSendbackbeforecheckup(3)} disabled={selectedBills.length <= 0 ? true : loading}
                                                style={{
                                                    display: 'flex', alignItems: 'center', gap: '3px', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                                    background: selectedBills.length <= 0 ? (
                                                        'rgba(141, 141, 141, 0.97)'
                                                    ) : ('linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)'), color: 'white', borderRadius: '8px',
                                                    cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                                }}
                                            ><img src='/Send-Back-Selected32.png' style={{ width: '1rem', height: "1rem", filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Send Back Selected'}
                                            </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorApproval;